import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const protocolsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Protocol_other',
    route: { name: routenames.protocols.index },
  },
];
